import { Navigate, Outlet, useLocation } from 'react-router-dom';
import Seo from '@/shared/components/ui/Seo/Seo';
import { loginPathFor } from '@/shared/utils/loginRedirect';
import { useAuthStore } from '@/store/authStore';

// Store pages that need a signed-in customer. A visitor (or a session ended by
// a 401, which clears the auth store) goes to the login page and comes back
// here after signing in. The backend still checks every request.
// These pages are personal, so search engines are asked to leave them out.
const RequireLogin = () => {
  const location = useLocation();
  const isLogin = useAuthStore((state) => state.isLogin);

  if (!isLogin) {
    return <Navigate to={loginPathFor(location)} replace />;
  }
  return (
    <>
      <Seo noindex />
      <Outlet />
    </>
  );
};

export default RequireLogin;
